module.exports = __webpack_public_path__ + "img/item5.36e9175d.png";